import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/event/cross_fm/00_02_kv.jpeg'
import _imports_1 from '@/assets/img/event/cross_fm/01_02sozai1.png'
import _imports_2 from '@/assets/img/event/cross_fm/03_02sozai.png'
import _imports_3 from '@/assets/img/event/cross_fm/03_04ランキング１位.png'
import _imports_4 from '@/assets/img/event/cross_fm/03_05特別審査員賞1.png'
import _imports_5 from '@/assets/img/event/cross_fm/03_06特別審査員賞2.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-320abc0e")

_pushScopeId("data-v-320abc0e")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "kv",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "main-container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "main-top" }, [
  /*#__PURE__*/_createVNode("div", { class: "main-top-container" }, [
    /*#__PURE__*/_createVNode("p", { class: "main-top-container-headline" }, "渋谷クロスFM『渋谷全力ドリーム3』での"),
    /*#__PURE__*/_createVNode("p", { class: "main-top-container-headline-second" }, "ラジオ出演をかけたオーディションを開催！"),
    /*#__PURE__*/_createVNode("p", { class: "main-content-bottom" }, [
      /*#__PURE__*/_createTextVNode("番組のテーマは、“夢”。"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("夢を叶えた人、夢に向かって頑張っている人、"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("夢はあるけど踏み出せないでいる人、夢を探している人。"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("そんな人たちに向けて、夢とともに生きている木村結香が、毎回スペシャルなゲストも交えて語り尽くす、刺激たっぷりの生放送情報番組。"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("受賞特典には、MCアシスタント＋番組内コーナーゲストとしての出演の他、番組内30秒CM出演のチャンスも♪")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "photograph" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "photograph-circle-img",
      src: _imports_1
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "event-info" }, [
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "開催期間・概要"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail-date" }, "2022年4月1日（金）00:00:00 ~ 2022年4月14日（木）23:59:59"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, "参加資格：年齢、性別不問"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, [
      /*#__PURE__*/_createTextVNode("※本イベントにおいて生じる交通費・宿泊費・出演料の支給はございませんので、予めご了承ください。"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("※公開スタジオでの生放送出演のため、"),
      /*#__PURE__*/_createVNode("span", { class: "with-border-text" }, "顔出しが必要"),
      /*#__PURE__*/_createTextVNode("となります。")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "スタートダッシュ期間"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, [
      /*#__PURE__*/_createVNode("span", { class: "with-border-text" }, "4/1 ~ 3までの3日間連続"),
      /*#__PURE__*/_createTextVNode("で通話が成立した方には、最終日4/14のポイントが1.1倍！"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("さらにonlylive公式Twitterにてイベント期間中に紹介ツイートが投稿されます✨")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "event-info-headline" }, "Twitterリツイートポイント"),
    /*#__PURE__*/_createVNode("p", { class: "event-info-detail" }, [
      /*#__PURE__*/_createTextVNode("必要事項を満たしたツイートを行っていただいた場合、そのツイートのリツイート数がイベントランキングポイントに反映されます！"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("→ 必要事項の詳細は運営事務局へお問い合わせください。"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("※１リツイートにつき10ポイント"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("※ツイート期限："),
      /*#__PURE__*/_createVNode("span", { class: "with-border-text" }, "4/7 23:59:59"),
      /*#__PURE__*/_createTextVNode("まで"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("※リツイート期限："),
      /*#__PURE__*/_createVNode("span", { class: "with-border-text" }, "4/14 17:59:59"),
      /*#__PURE__*/_createTextVNode("まで"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("※"),
      /*#__PURE__*/_createVNode("span", { class: "with-border-text" }, "4/14 21:00以降順次"),
      /*#__PURE__*/_createTextVNode("反映")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "entry-form-content" }, [
      /*#__PURE__*/_createVNode("span", null, "＼飛び込みオーディション参加可能／"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("onlylive配信をご希望の方はこちら")
    ]),
    /*#__PURE__*/_createVNode("a", {
      class: "photograph-btn",
      href: "https://onlylive.tokyo/talent#contact",
      target: "_brank"
    }, [
      /*#__PURE__*/_createVNode("p", { class: "entry-form-btn-content" }, "応募フォーム")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "event-info-title" }, "『渋谷全力ドリーム3』"),
    /*#__PURE__*/_createVNode("a", {
      class: "event-info-link",
      href: "#benefits"
    }, "▼オーディション情報はこちら▼")
  ])
], -1)
const _hoisted_5 = { class: "event-ranking-body-section" }
const _hoisted_6 = { class: "ranking-section" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "partner-info" }, [
  /*#__PURE__*/_createVNode("p", { class: "partner-info-headline" }, "『渋谷全力ドリーム３』情報"),
  /*#__PURE__*/_createVNode("div", { class: "partner-info-detail" }, [
    /*#__PURE__*/_createVNode("p", { class: "partner-info-detail-item" }, "ラジオ局"),
    /*#__PURE__*/_createVNode("p", { class: "partner-info-detail-colon" }, "："),
    /*#__PURE__*/_createVNode("p", { class: "partner-info-detail-contents" }, "渋谷クロスFM（東京都渋谷区神南1-12-10 シダックスカルチャービレッジ1階）")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "partner-info-detail" }, [
    /*#__PURE__*/_createVNode("p", { class: "partner-info-detail-item" }, "番組"),
    /*#__PURE__*/_createVNode("p", { class: "partner-info-detail-colon" }, "："),
    /*#__PURE__*/_createVNode("p", { class: "partner-info-detail-contents" }, "『渋谷全力ドリーム3』")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "partner-info-detail" }, [
    /*#__PURE__*/_createVNode("p", { class: "partner-info-detail-item" }, "出演者"),
    /*#__PURE__*/_createVNode("p", { class: "partner-info-detail-colon" }, "："),
    /*#__PURE__*/_createVNode("p", { class: "partner-info-detail-contents" }, [
      /*#__PURE__*/_createTextVNode("木村結香（"),
      /*#__PURE__*/_createVNode("span", null, [
        /*#__PURE__*/_createVNode("a", {
          class: "official-info",
          href: "https://www.kimura-yuka.com/",
          target: "_blank"
        }, "公式HP")
      ]),
      /*#__PURE__*/_createTextVNode("）、他キャスト調整中")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "partner-info-detail" }, [
    /*#__PURE__*/_createVNode("p", { class: "partner-info-detail-item" }, "放送"),
    /*#__PURE__*/_createVNode("p", { class: "partner-info-detail-colon" }, "："),
    /*#__PURE__*/_createVNode("p", { class: "partner-info-detail-contents-date" }, "毎月第4火曜日 12:00 ~ 13:00（内20分程度のコーナー出演）")
  ]),
  /*#__PURE__*/_createVNode("p", { class: "partner-info-detail" }, "※アーカイブ有り（媒体未定、映像でのアーカイブとなります）"),
  /*#__PURE__*/_createVNode("img", {
    class: "partner-info-img",
    src: _imports_2
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { id: "benefits" }, [
  /*#__PURE__*/_createVNode("div", { class: "benefits-section" }, [
    /*#__PURE__*/_createVNode("span", null, [
      /*#__PURE__*/_createVNode("p", { class: "benefits-section-headline" }, "ランキング特典"),
      /*#__PURE__*/_createVNode("p", { class: "benefits-section-caution" }, "エントリー前に必ず日程をご確認ください。"),
      /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
        /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
          /*#__PURE__*/_createVNode("img", {
            class: "rank-banner",
            src: _imports_3
          })
        ]),
        /*#__PURE__*/_createVNode("div", { class: "benefits-common" }, [
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-headline" }, "番組出演権（2回）"),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail" }, [
            /*#__PURE__*/_createTextVNode("アシスタントMC・コーナーゲストとしてご出演いただきます。"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("（20分程度のご出演予定）")
          ]),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail-caution" }, "放送（収録）予定日：4/26, 5/24")
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
        /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
          /*#__PURE__*/_createVNode("img", {
            class: "rank-banner",
            src: _imports_4
          })
        ]),
        /*#__PURE__*/_createVNode("div", { class: "benefits-common" }, [
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail-remarks" }, "（2 ~ 5位から1名）"),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-headline" }, "番組出演権（1回）"),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail" }, [
            /*#__PURE__*/_createTextVNode("アシスタントMC・コーナーゲストとしてご出演いただきます。"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("（20分程度のご出演予定）")
          ]),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail-caution" }, "放送（収録）予定日：6/28")
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
        /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
          /*#__PURE__*/_createVNode("img", {
            class: "rank-banner",
            src: _imports_5
          })
        ]),
        /*#__PURE__*/_createVNode("div", { class: "benefits-common" }, [
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail" }, "（TOP10位以内から3名）"),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-headline" }, "番組内30秒CM放送権"),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail" }, "※音声のみの出演となります"),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail" }, [
            /*#__PURE__*/_createTextVNode("※期限までにご自身で音声データを"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("ご用意いただきます。")
          ]),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail-date" }, "放送予定日：4/26, 5/24, 6/28（各1名ずつ放送）"),
          /*#__PURE__*/_createVNode("p", { class: "benefits-common-detail-caution" }, "提出期限:4/16 18:00"),
          /*#__PURE__*/_createVNode("p", { class: "entry-form-content" }, [
            /*#__PURE__*/_createVNode("span", null, "＼飛び込みオーディション参加可能／"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("onlylive配信をご希望の方はこちら")
          ]),
          /*#__PURE__*/_createVNode("a", {
            class: "photograph-btn",
            href: "https://onlylive.tokyo/talent#contact",
            target: "_brank"
          }, [
            /*#__PURE__*/_createVNode("p", { class: "entry-form-btn-content" }, "応募フォーム")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "notes-section" }, [
  /*#__PURE__*/_createVNode("div", { class: "notes-section-container" }, [
    /*#__PURE__*/_createVNode("p", { class: "notes-top-title" }, "注意事項"),
    /*#__PURE__*/_createVNode("ul", { class: "notes-contents" }, [
      /*#__PURE__*/_createVNode("li", null, "・審査の過程や受賞者の決定に至った理由等につきましてはお答えできませんので予めご了承ください。"),
      /*#__PURE__*/_createVNode("li", null, "・2022年4月1日00時00分以降に通話を開始した分から、2022年4月14日23時59分59秒までに通話を開始した分がランキングに加算されます。"),
      /*#__PURE__*/_createVNode("li", null, "・2022年4月14日23時59分59秒に通話が開始された場合、終了するまでがランキングに加算されます。（延長分も加算されます）"),
      /*#__PURE__*/_createVNode("li", null, "・最終ランキングの発表は、2022年4月15日を予定しております。")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "footer" }, [
    /*#__PURE__*/_createVNode("p", null, "© 2022 ILEO,inc.")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Ranking = _resolveComponent("Ranking")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Ranking, {
            event: _ctx.state.event,
            rankingUsers: _ctx.state.ranking,
            getRankingPath: "ranking_2203_cross_fm",
            getEnableEventPath: "enable_2203_cross_fm",
            isPreEvent: false,
            showRankingCount: 5
          }, null, 8, ["event", "rankingUsers"])
        ])
      ]),
      _hoisted_7,
      _hoisted_8
    ]),
    _hoisted_9
  ]))
})